(function () {
  'use strict';

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function debounce(callback, delay) {
    var timer;

    return function () {
      var context = this;
      var args = arguments;

      window.clearTimeout(timer);

      timer = window.setTimeout(function () {
        callback.apply(context, args);
      }, delay);
    };
  }

  function initializeStoreLocator(root) {
    if (!root || root.dataset.storeLocatorReady === 'true') {
      return;
    }

    root.dataset.storeLocatorReady = 'true';

    var input = root.querySelector('[data-store-locator-input]');
    var clearButton = root.querySelector('[data-store-locator-clear]');
    var countElement = root.querySelector('[data-store-locator-count]');
    var emptyElement = root.querySelector('[data-store-locator-empty]');
    var stores = Array.prototype.slice.call(
      root.querySelectorAll('[data-store]')
    );

    if (!stores.length) {
      if (countElement) {
        countElement.textContent = 'No stores are currently available.';
      }

      if (emptyElement) {
        emptyElement.hidden = false;
      }

      return;
    }

    stores.forEach(function (store) {
      /*
       * Add a class to stores that have no opening-hours column.
       * This allows their address information to span the full card.
       */
      if (!store.querySelector('.store-card__hours')) {
        store.classList.add('store-card--no-hours');
      }

      /*
       * Build the searchable value using both data-store-search
       * and visible card text. This ensures phone numbers and any
       * updated address text also remain searchable.
       */
      var suppliedSearchValue =
        store.getAttribute('data-store-search') || '';

      store.dataset.normalizedSearch = normalizeSearchValue(
        suppliedSearchValue + ' ' + store.textContent
      );
    });

    function updateStoreCount(visibleCount, query) {
      if (!countElement) {
        return;
      }

      var storeWord = visibleCount === 1 ? 'store' : 'stores';

      if (query) {
        countElement.textContent =
          visibleCount +
          ' ' +
          storeWord +
          ' found for "' +
          query +
          '"';
      } else {
        countElement.textContent =
          visibleCount + ' ' + storeWord + ' available';
      }
    }

    function filterStores() {
      var rawQuery = input ? input.value.trim() : '';
      var normalizedQuery = normalizeSearchValue(rawQuery);
      var queryParts = normalizedQuery
        ? normalizedQuery.split(' ')
        : [];

      var visibleCount = 0;

      stores.forEach(function (store) {
        var searchableValue =
          store.dataset.normalizedSearch || '';

        /*
         * Every search word must appear somewhere in the store data.
         * Example: "john london" matches a John Lewis London location.
         */
        var matches = queryParts.every(function (queryPart) {
          return searchableValue.indexOf(queryPart) !== -1;
        });

        store.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      if (clearButton) {
        clearButton.hidden = rawQuery.length === 0;
      }

      if (emptyElement) {
        emptyElement.hidden = visibleCount !== 0;
      }

      updateStoreCount(visibleCount, rawQuery);
    }

    var debouncedFilter = debounce(filterStores, 120);

    if (input) {
      input.addEventListener('input', debouncedFilter);

      input.addEventListener('search', function () {
        filterStores();
      });

      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value) {
          input.value = '';
          filterStores();
          input.focus();
        }
      });
    }

    if (clearButton && input) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        filterStores();
        input.focus();
      });
    }

    filterStores();
  }

  function initializeAllStoreLocators(scope) {
    var searchScope = scope || document;

    if (
      searchScope.nodeType === 1 &&
      searchScope.matches &&
      searchScope.matches('[data-store-locator]')
    ) {
      initializeStoreLocator(searchScope);
    }

    var roots = searchScope.querySelectorAll
      ? searchScope.querySelectorAll('[data-store-locator]')
      : [];

    Array.prototype.forEach.call(roots, function (root) {
      initializeStoreLocator(root);
    });
  }

  function startStoreLocators() {
    initializeAllStoreLocators(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startStoreLocators
    );
  } else {
    startStoreLocators();
  }

  /*
   * Reinitialize when Shopify reloads a section inside
   * the Theme Editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllStoreLocators(event.target);
    }
  );
})();